import type { SagaIterator } from 'redux-saga';
import { debounce, put, takeEvery } from 'redux-saga/effects';

import bugsnag from '@app/utils/bugsnag';

import * as socketActions from '../../../../sockets/socketActions';
import { getActiveCount } from '../../pages/ProjectsList/api';
import type { ActiveCountResponse } from '../../pages/ProjectsList/types';
import { badgeActions } from './reducers';

const { getBadgeStatus } = badgeActions;

function* getBackgroundActivityBadges({ payload }: ReturnType<typeof getBadgeStatus>) {
    try {
        const apiPayload = [
            {
                id: payload.projectId,
                branch: payload.branchId,
            },
        ];

        const { data }: { data: ActiveCountResponse } = yield getActiveCount(apiPayload);
        yield put(
            badgeActions.setBackgroundActivityBadges({
                backgroundActivityBadges: data,
                ...payload,
            }),
        );
    } catch (e) {
        bugsnag.log(`Get active count data error, error: ${e}`);
    }
}

function* initActiveCountSocketListener(payload: ReturnType<typeof getBadgeStatus>): SagaIterator {
    yield debounce(2000, [socketActions.bgProcessCountChanged.match], () => getBackgroundActivityBadges(payload));
}

export default function* initProjectSagas() {
    yield takeEvery(getBadgeStatus.match, getBackgroundActivityBadges);
    yield takeEvery(getBadgeStatus.match, initActiveCountSocketListener);
}
